import { Typography } from '@mui/material';
import { addYears } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { ConnectedDateRangePicker } from 'shared/components';

import { ReasonInputBaseProps } from './BaseInput';
import FieldFreeText from './FieldFreeText';

export default function AvailabilityInput(props: ReasonInputBaseProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails' });

    return (
        <>
            <Typography>{ t('reasonInput.availability.label') }</Typography>
            <ConnectedDateRangePicker control={ props.control }
                name="reasonInput.value"
                disablePast
                maxDate={ addYears(new Date(), 1) }
            />
            <FieldFreeText { ...props } />
        </>
    );
}
